/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */
import React, { useRef, useLayoutEffect, useCallback } from 'react';

import { evalLegacyConnectInlineScripts } from '@confluence/connect-utils';
import { useExtensionDimensions } from '@confluence/browser-metrics/entry-points/useExtensionDimensions.ts';
import { usePageState } from '@confluence/page-context';
import { ATL_GENERAL } from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';

type WebPanelProps = {
	html: string;
	/**
	 * Unique identifier for this web panel instance
	 */
	panelId?: string;
	panelLocation?: string;
};

export function WebPanel({ html, panelId, panelLocation }: WebPanelProps): React.JSX.Element {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const [{ contentId, spaceKey }] = usePageState();
	const dimensionsRef = useExtensionDimensions(
		panelLocation === ATL_GENERAL ? ATL_GENERAL : undefined,
		panelId,
		contentId || spaceKey || '',
	);
	const panelRef = useCallback(
		(element: HTMLDivElement | null) => {
			containerRef.current = element;
			dimensionsRef(element);
		},
		[dimensionsRef],
	);
	useLayoutEffect(() => {
		const container = containerRef.current;

		if (!container) {
			return;
		}

		void evalLegacyConnectInlineScripts(container);
	}, [html, panelId]);

	return (
		<div
			ref={panelRef}
			data-vc-ignore-if-no-layout-shift
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	);
}
